﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { IRoutingComponent, RouteConfig } from "@fiqas/ngcomponentrouter";
import { FIQAssist } from "../../app";
import { Application } from "../application"
import { IDisposable } from "../../interfaces/general";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { Request } from "../../models/serviceCase"
import { ServiceCaseBase } from "../general/serviceCaseBase"
import { CacheService } from "../../services/cache";
import { SaveDialog } from "../general/savedialog";
import { AuthorizationService } from "../../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "requestBase",
    templateUrl: ServiceCaseBase.template
})
@RouteConfig([
    { path: '/new', name: "New", component: "requestEntry", useAsDefault: true },
    { path: '/edit/:number', name: "Edit", component: "requestEdit" },
    { path: '/edit/:number/:id', name: "EditWithId", component: "requestEdit" }
]
)
export class RequestBase extends ServiceCaseBase<Request> {

    constructor(
        @Inject() protected authorizationService: AuthorizationService,
        @Inject() protected cacheService: CacheService,
        @Inject('$rootRouter') rootRouter: angular.Router,
        @Inject('$timeout') timeout: angular.ITimeoutService,
        @Inject('$location') location: angular.ILocationService,
    ) {
        super(authorizationService, cacheService, rootRouter, timeout, location);
    }

}
